var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#D8E1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0006 14.3438C31.4245 14.3438 27.7148 18.0534 27.7148 22.6295C27.7148 27.2055 31.4245 30.9152 36.0006 30.9152C40.5766 30.9152 44.2863 27.2055 44.2863 22.6295C44.2863 18.0534 40.5766 14.3438 36.0006 14.3438ZM23.7148 22.6295C23.7148 15.8443 29.2153 10.3438 36.0006 10.3438C42.7858 10.3438 48.2863 15.8443 48.2863 22.6295C48.2863 29.4147 42.7858 34.9152 36.0006 34.9152C29.2153 34.9152 23.7148 29.4147 23.7148 22.6295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5104 43.3837C27.0931 40.6346 31.4828 39.1445 35.9987 39.1445C40.5146 39.1445 44.9043 40.6346 48.487 43.3837C52.0697 46.1328 54.6451 49.9873 55.8139 54.3493C56.0998 55.4163 55.4667 56.5129 54.3997 56.7988C53.3328 57.0847 52.2361 56.4515 51.9502 55.3846C51.0093 51.8731 48.9361 48.7702 46.0519 46.5572C43.1678 44.3441 39.634 43.1445 35.9987 43.1445C32.3633 43.1445 28.8295 44.3441 25.9454 46.5572C23.0613 48.7702 20.988 51.8731 20.0471 55.3846C19.7612 56.4515 18.6645 57.0847 17.5976 56.7988C16.5307 56.5129 15.8975 55.4163 16.1834 54.3493C17.3522 49.9873 19.9277 46.1328 23.5104 43.3837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUserAvatar);
export default __webpack_public_path__ + "static/media/EmptyUserAvatar.4b5721ae7e60608f60f8320fbd682899.svg";
export { ForwardRef as ReactComponent };